import React from 'react';
import { compose, graphql } from 'react-apollo';

import { EmailMessageAssignToClaim } from '../../../mutations/EmailMessageAssignToClaim';
import { UpdateTask } from '../../../mutations/UpdateTask';
import withEmailMessage from './withEmailMessage';
import TaskView from './TaskView';

class AssignMessageTask extends React.Component {
  state = {};

  handleAssignClick = id => {
    this.setState({ isConfirmationOpen: true, claimToAssign: id });
  };
  handleConfirmation = assign => {
    if (assign) {
      return this.handleAssignClaim();
    }
    this.setState({ isConfirmationOpen: false });
  };
  handleAssignClaim = () => {
    this.setState({ loading: true });
    this.props
      .AssignEmail({
        variables: {
          input: {
            claimId: this.state.claimToAssign,
            emailMessageId: this.props.task.emailMessage.id,
            taskId: this.props.task.id
          }
        }
      })
      .then(() => {
        this.setState({ loading: false });
        this.props.onTaskComplete();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleReject = () => {
    this.setState({ loading: true });
    this.props
      .UpdateTask({
        variables: {
          input: {
            id: this.props.task.id,
            status: 'closed'
          }
        }
      })
      .then(() => {
        this.setState({ loading: false });
        this.props.onTaskComplete();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { emailMessageLoading } = this.props;
    const { claimToAssign, isConfirmationOpen, loading } = this.state;
    return (
      <TaskView
        {...this.props}
        claimToAssign={claimToAssign}
        isConfirmationOpen={isConfirmationOpen}
        loading={emailMessageLoading || loading}
        onConfirmation={this.handleConfirmation}
        onAssignClick={this.handleAssignClick}
        onReject={this.handleReject}
      />
    );
  }
}

const AssignMessageTaskWithData = compose(
  withEmailMessage,
  graphql(EmailMessageAssignToClaim, { name: 'AssignEmail' }),
  graphql(UpdateTask, { name: 'UpdateTask' }),
)(AssignMessageTask);

export default AssignMessageTaskWithData;



// WEBPACK FOOTER //
// ./src/component/tasks/AssignMessageTask/index.js